import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../../../img/logo rio verde pdf.png';

const generateOrdemServicoReport = (vehicle, servico, fornecedor) => {
    const currentUser = localStorage.getItem('username') || 'N/A';

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let currentY = 15;

    const themeColor = [22, 160, 133];
    const lightGreenBg = [240, 253, 250];
    const darkText = [30, 41, 59];
    const lightText = [100, 116, 139];

    doc.addImage(logo, 'PNG', 14, currentY, 40, 15);
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    doc.text('ORDEM DE SERVIÇO', pageWidth - 14, currentY + 5, { align: 'right' });
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(lightText[0], lightText[1], lightText[2]);
    doc.text(`OS Nº: ${servico.numero_os || 'N/A'}`, pageWidth - 14, currentY + 11, { align: 'right' });

    currentY += 30;

    const infoBoxWidth = (pageWidth - 28 - 10) / 2;
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(0.3);

    doc.roundedRect(14, currentY, infoBoxWidth, 30, 3, 3, 'D');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(themeColor[0], themeColor[1], themeColor[2]);
    doc.text('FORNECEDOR', 20, currentY + 7);
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    doc.text(`Razão Social: ${fornecedor.nome_empresa || ''}`, 20, currentY + 14);
    doc.text(`CNPJ: ${fornecedor.cnpj || ''}`, 20, currentY + 19);
    doc.text(`Telefone: ${fornecedor.telefone || ''}`, 20, currentY + 24);

    doc.roundedRect(14 + infoBoxWidth + 10, currentY, infoBoxWidth, 30, 3, 3, 'D');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(themeColor[0], themeColor[1], themeColor[2]);
    doc.text('VEÍCULO', 20 + infoBoxWidth + 10, currentY + 7);
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);
    doc.text(`Veículo: ${vehicle.marca || ''} ${vehicle.modelo || ''}`, 20 + infoBoxWidth + 10, currentY + 14);
    
    if (vehicle.placa) {
        doc.text(`Placa: ${vehicle.placa}`, 20 + infoBoxWidth + 10, currentY + 19);
    }
    
    doc.text(`KM Atual: ${vehicle.quilometragem || ''} km`, 20 + infoBoxWidth + 10, currentY + 24);

    currentY += 40;

    const tableBody = servico.itens.map(item => {
        const quantidade = parseFloat(item.quantidade) || 0;
        const valorUnitario = parseFloat(item.valor_unitario) || 0;
        const valorTotal = quantidade * valorUnitario;

        return [
            item.descricao,
            quantidade.toFixed(2).replace('.', ','),
            item.unidade || 'UN',
            valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        ];
    });

    const totalOs = servico.itens.reduce((acc, item) => {
        const quantidade = parseFloat(item.quantidade) || 0;
        const valorUnitario = parseFloat(item.valor_unitario) || 0;
        return acc + (quantidade * valorUnitario);
    }, 0);
    
    doc.autoTable({
        startY: currentY,
        head: [['Descrição do Serviço / Peça', 'Qtd.', 'Unid.', 'Vl. Unitário', 'Vl. Total']],
        body: tableBody,
        theme: 'striped',
        headStyles: { 
            fillColor: themeColor,
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            halign: 'center',
            fontSize: 10
        },
        bodyStyles: {
            textColor: darkText,
            fontSize: 9
        },
        alternateRowStyles: {
            fillColor: lightGreenBg
        },
        foot: [['', '', '', 'VALOR TOTAL', totalOs.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })]],
        footStyles: { 
            fontStyle: 'bold',
            fontSize: 11,
            halign: 'right',
            fillColor: [255, 255, 255],
            textColor: themeColor,
            lineColor: themeColor,
            lineWidth: 0.3
        },
        columnStyles: {
            1: { halign: 'center' },
            2: { halign: 'center' },
            3: { halign: 'right' },
            4: { halign: 'right' }
        }
    });

    currentY = doc.lastAutoTable.finalY + 15;

    if (servico.observacoes_gerais) {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(darkText[0], darkText[1], darkText[2]);
        doc.text('Observações:', 14, currentY);
        currentY += 6;
        
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(lightText[0], lightText[1], lightText[2]);
        
        const splitObservations = doc.splitTextToSize(servico.observacoes_gerais, pageWidth - 28);
        
        for (let i = 0; i < splitObservations.length; i++) {
            if (currentY > pageHeight - 60) {
                doc.addPage();
                currentY = 20;
            }
            doc.text(splitObservations[i], 14, currentY);
            currentY += 5;
        }
    }

    if (currentY > pageHeight - 60) {
        doc.addPage();
        currentY = 20;
    }

    const signatureY = pageHeight - 50;
    const finalSignatureY = currentY > signatureY - 10 ? pageHeight - 50 : signatureY;

    if (currentY > pageHeight - 70) {
        doc.addPage();
        currentY = 40;
    } else {
        currentY += 20;
    }

    doc.setFontSize(10);
    doc.setTextColor(darkText[0], darkText[1], darkText[2]);

    doc.line(20, currentY + 10, 90, currentY + 10);
    doc.text('Assinatura do Responsável (Contratante)', 55, currentY + 15, { align: 'center' });

    doc.line(pageWidth - 90, currentY + 10, pageWidth - 20, currentY + 10);
    doc.text('Assinatura do Fornecedor (Contratado)', pageWidth - 55, currentY + 15, { align: 'center' });

    doc.setDrawColor(themeColor[0], themeColor[1], themeColor[2]);
    doc.setLineWidth(0.5);
    doc.line(14, pageHeight - 20, pageWidth - 14, pageHeight - 20);
    
    doc.setFontSize(8);
    doc.setTextColor(lightText[0], lightText[1], lightText[2]);
    
    const userText = `Gerado por: ${currentUser}`;
    doc.text(userText, 14, pageHeight - 12);
    
    const generatedText = `Sistema de Frota | ${new Date().toLocaleDateString('pt-BR')}`;
    doc.text(generatedText, pageWidth - 14, pageHeight - 12, { align: 'right' });
    
    const fileName = `os_${vehicle.placa || 'veiculo'}_${servico.numero_os || servico.id}.pdf`;
    doc.save(fileName);
};

export default generateOrdemServicoReport;